import '../../fonts/LLBrown/fontface.css';

import BackgroundImage from '../../images/gammeldansk/Gammeldansk-bg.jpg';

const colors = {
  black: 'rgb(0, 0, 0)',
  white: 'rgb(255, 255, 255)',
  white50: 'rgba(255, 255, 255, 0.5)',
  gray: 'rgb(204, 204, 204)',
  lighterGray: 'rgb(244, 245, 246)',
  lightGray: 'rgb(230, 230, 230)',
  mediumGray: 'rgb(155, 155, 155)',
  mediumGray2: 'rgb(129, 129, 129)',
  darkGray: 'rgb(51, 51, 51)',
  blue: 'rgb(70, 152, 202)',
  lightBlue: 'rgb(209, 231, 236)',
  darkBlue: 'rgb(113, 134, 140)',
  green: 'rgb(116, 165, 74)',
  lightGreen: 'rgb(232, 236, 226)',
  darkGreen: 'rgb(136,144,129)',
  darkPurple: 'rgb(66,44,64)',
  lightPurple: 'rgb(180, 156, 185)',
  red: 'rgb(200, 49, 69)',
  lighterRed: ' rgb(222, 194, 194)',
  darkRed: ' rgb(95, 39, 39)',
  darkBrown: 'rgb(95,66,64)',
  darkerBrown: 'rgb(71, 64, 64)',
  lightBrown: 'rgb(229,222,217)',
  lightYellow: 'rgb(255, 246, 233)',

  brightOrange: '#e68532',
  brightBlue: '#3b91a4',
  brightYellow: '#ffd700',
  brightGreen: '#7b9f34',
  brightBrown: '#86482c',
};

const breakPoints = {
  xs: 0,
  sm: 600,
  md: 840,
  lg: 1280,
  xl: 1920,
};

const textFontFamilies = {
  fontTypography: 'LL Brown, sans-serif',
  fontBody1: 'LL Brown, sans-serif',
  fontBody2: 'LL Brown, sans-serif',
  fontHeadings: 'LL Brown, sans-serif',
};

const textFontSizesMobile = {
  fontSizeLeadText: '1.125rem',
  fontSizeTypography: '0.938rem',
  fontSizeButton: '0.875rem',
  fontSizeBody1: '0.938rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '2.625rem',
  fontSizeH2: '1.75rem',
  fontSizeH3: '1.188rem',
  fontSizeH4: '1.125rem',
};
const textFontSizesDesktop = {
  fontSizeLeadText: '1.188rem',
  fontSizeTypography: '1rem',
  fontSizeButton: '1rem',
  fontSizeBody1: '1rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '4rem',
  fontSizeH2: '2.5rem',
  fontSizeH3: '1.5rem',
  fontSizeH4: '1.125rem',
};
const textFontWeight = {
  typography: 'normal',
  button: '600',
  body1: 'normal',
  body2: 'normal',
  h1: '700',
  h2: '700',
  h3: '700',
  h4: '700',
};
const textLineHeightsMobile = {
  lineHeightLeadText: '1.5',
  lineHeightQuote: '1.5',
  lineHeightBody1: '1.5',
  lineHeightBody2: '1.47',
  lineHeightHeadings: 'normal',
};

const textLineHeightsDesktop = {
  lineHeightLeadText: '1.58',
  lineHeightQuote: '1.5',
  lineHeightBody1: '1.5',
  lineHeightBody2: '1.54',
  lineHeightHeadings: 'normal',
};

const typography = {
  h1: {
    marginBottom: '2.5rem',
  },
  h2: {
    marginBottom: '1.75rem',
    textTransform: 'uppercase',
  },
  h3: {
    marginBottom: '1rem',
  },
  h4: {
    marginBottom: '1rem',
  },
  h5: {
    marginBottom: '1rem',
  },
  h6: {
    marginBottom: '1rem',
  },
};

const pageTemplates = {
  landingPage: {
    mobile: {
      paddingTop: 24.875, // => value x 8px
    },
    desktop: {
      paddingTop: 24.875, // => value x 8px
    },
  },
  otherPageTemplates: {
    mobile: {
      paddingTop: 30, // => value x 8px
    },
    desktop: {
      paddingTop: 29, // => value x 8px
    },
  },
};

const brandColors = {
  primary: '#FFE190',
  accent: '#F5F422',
};

const textColors = {
  bodyText: '#000000',
  headingColor: '#9f161a',
  mutedText: '#7D7D7D',
  disabledText: '#B9B9B9',
  lightText: colors.white,
};

const linkColors = {
  link: '#9f161a',
  linkHover: '#611717',
  linkPressed: '#611717',
};

const iconColors = {
  iconColor: '#210101',
};

const backgroundColors = {
  paper: '#f3f1eb',
  grayLight: '#f3f1eb',
  grayDark: '#373737',
  goldLight: '#F1E8E2',
  overlay: 'rgba(51,51,51,0.5)',
};

const formColors = {
  inputBorder: '#B4B4B4',
  inputBackground: '#7d7d7d',
  inputActiveBackground: '#ffffff',
  inputActiveBorder: '#210101',
};

const primaryButtonColors = {
  primaryButtonBackground: '#210101',
  primaryButtonBackgroundGradient: 'radial-gradient(circle at 50% 50%, #611717, #210101 75%)',
  primaryButtonHoveredBackground: '#210101',
  primaryButtonPressedBackground: '#210101',
  primaryButtonDisabledBackground: '#9d9191',
  primaryButtonContents: '#FFFFFF',
};
const secondaryButtonColors = {
  secondaryButtonBackground: '#611717',
  secondaryButtonHoveredBackground: '#210101',
  secondaryButtonPressedBackground: '#210101',
  secondaryButtonDisabledBackground: '9d9191',
  secondaryButtonContents: '#FFFFFF',
};

const outlinedButtonColors = {
  outlinedButton: '#611717',
  outlinedButtonHovered: '#210101',
  outlinedButtonPressed: '#210101',
  outlinedButtonDisabled: '#9d9191',
  outlinedButtonHoveredBackground: '#611717',
};

const buttonSettings = {
  buttonPaddingDesktop: '12px 24px',
  buttonPaddingMobile: '8px 16px',
  borderRadius: '0',
  textTransform: 'inherit',
};

const notificationColors = {
  infoBackground: '#E7EEF8',
  successBackground: '#E9F8EA',
  warningBackground: '#FDF2E9',
  errorBackground: '#F6E6E6',

  infoContents: '#3D68A8',
  successContents: '#218E2C',
  warningContents: '#E8770E',
  errorContents: '#D71717',
};

const header = {
  text: '#210101',
  background: `${brandColors.primary} url(${BackgroundImage}) repeat`,
  minHeight: '199px',
  paddingYDesktop: '80px',
  paddingYMobile: '80px',
  navigation: {
    activeLink: linkColors.linkPressed,
    activeLinkBorder: 'none',
    hoverText: linkColors.linkHover,
    subMenuBackground: colors.white,
    subMenuBulletPoints: colors.white,
  },
  border: {
    bottomWidth: '0',
    style: 'none',
  },
  icons: {
    color: colors.white,
    backgroundColor: colors.black,
  },
};

const footer = {
  border: {
    color: 'transparent',
    width: '3px',
  },
  divider: brandColors.accent,
  text: textColors.bodyText,
  background: `${brandColors.primary} url(${BackgroundImage}) repeat`,
  logoBarBackground: brandColors.primary,
  padding: {
    bottom: '50px',
  },
};

const accordion = {
  backgroundColor: backgroundColors.grayLight,
  borderRadius: '12px',
  color: linkColors.link,
  flexDirection: 'row',
  titleFontSize: '1.125rem',
  hover: {
    backgroundColor: colors.white,
    color: linkColors.linkHover,
  },
  expandIcon: {
    backgroundColor: 'inherit',
    hover: {
      backgroundColor: 'inherit',
    },
  },
  padding: {
    left: '12px',
    right: '8px',
  },
};

const languageSelector = {
  border: {
    color: colors.black,
    width: '1px',
  },
  margin: '0 30px 0 0',
};

const table = {
  border: `solid 1px ${brandColors.accent}`,
  borderRadius: '4px',
  head: {
    backgroundColor: brandColors.primary,
    color: textColors.bodyText,
  },
  row: {
    even: {
      backgroundColor: colors.white,
    },
  },
  cell: {
    border: `solid 1px ${brandColors.primaryDark}`,
  },
};

const category = {
  outlined: {
    background: backgroundColors.grayLight,
    text: linkColors.link,
  },
  text: linkColors.link,
  hoverText: linkColors.linkHover,
};

const mobileNavigation = {
  text: textColors.bodyText,
  icon: textColors.bodyText,
  xIconBackground: colors.lightBrown,
  logoBarBottomBorder: brandColors.primary,
  navigationElementBorder: colors.lightGray,
  subNavigationTitleBackground: brandColors.primary,
  subNavigationTitleColor: textColors.bodyText,
  drawer: {
    paper: {
      backgroundColors: backgroundColors.paper,
      widthDesktop: '350px',
    },
  },
};

export const gammeldanskPrimaryTheme = {
  colors,
  breakPoints,
  brandColors,
  textColors,
  textFontFamilies,
  textFontSizesMobile,
  textFontSizesDesktop,
  textFontWeight,
  textLineHeightsMobile,
  textLineHeightsDesktop,
  typography,
  pageTemplates,
  linkColors,
  iconColors,
  backgroundColors,
  formColors,
  primaryButtonColors,
  secondaryButtonColors,
  outlinedButtonColors,
  buttonSettings,
  notificationColors,
  header,
  footer,
  accordion,
  languageSelector,
  table,
  category,
  mobileNavigation,
};
